<template>
  <div class="row header">
    <template v-if="windowWidth < 769">
      <div class="zindex d-flex">
        <div class="d-flex">
          <b-button v-b-toggle.sidebar-right>
            <div class="hamburger-menu">
              <label for="check" class="menu">
                <div class="menu-line menu-line-1"></div>
                <div class="menu-line menu-line-2"></div>
                <div class="menu-line menu-line-3"></div>
              </label>
            </div>
          </b-button>
          <div class="col-sm-2 logo d-flex">
            <a href="http://eduaid.ir/">
              <img src="@/assets/images/logo.png" alt />
            </a>
          </div>
        </div>

        <b-sidebar id="sidebar-right" right shadow>
          <div class="logo d-flex">
            <a href="http://eduaid.ir/">
              <img src="@/assets/images/logo.png" alt />
            </a>
          </div>
          <div class="px-3 py-2">
            <div class="col-sm-12 col-lg-8 d-flex navbar">
              <ul class="nav">
                <router-link tag="li" :to="'/'" class="nav-item">
                  <a class="nav-link" href="#">خانه</a>
                </router-link>
                <router-link tag="li" :to="'./about-us'" class="nav-item">
                  <a class="nav-link" href="#">درباره ما</a>
                </router-link>
                <router-link tag="li" :to="'./our-services'" class="nav-item">
                  <a class="nav-link" href="#">خدمات ما</a>
                </router-link>
                <router-link tag="li" :to="'./contact-us'" class="nav-item">
                  <a class="nav-link" href="#">تماس با ما</a>
                </router-link>
                <router-link tag="li" :to="'./faq'" class="nav-item">
                  <a class="nav-link" href="#">سوالات متداول</a>
                </router-link>
              </ul>
            </div>
            <div class="col-sm-2 d-flex navbar-left nav nav-res">
              <div class="d-flex navbar-left-icon">
                <button v-b-tooltip.hover title="سبد خرید">
                  <i class="icon-shopping-line"></i>
                </button>
              </div>
            </div>
          </div>
        </b-sidebar>
        <div class="left-section">
          <div
            class="d-flex align-self-center navbar-left-enter user-navigator right-section"
          >
            <b-overlay
              :show="loadingLogin"
              variant="transparent"
              blur="3px"
              rounded="sm"
              spinner-variant="warning"
              spinner-type="grow"
            >
              <b-dropdown
                v-if="['real'].indexOf(user.user_type) == -1"
                size="lg"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="icon-user user-icon"></i>
                  <i class="icon-down arrow-down"></i>
                </template>

                <b-dropdown-item class="sign-in" v-b-modal.signin-real-person
                  >ورود</b-dropdown-item
                >

                <b-dropdown-item class="sign-up" v-b-modal.signup-real-person
                  >ثبت نام</b-dropdown-item
                >
              </b-dropdown>
            </b-overlay>

            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              v-if="user.user_type == 'real'"
              no-caret
            >
              <template v-slot:button-content>
                <div class="user-logged-info">
                  <p class="name" v-text="userFullname"></p>
                  <div
                    class="image-container"
                    v-if="userImage.indexOf('default.png') == -1"
                  >
                    <img :src="userImage" :alt="userFullname" />
                  </div>
                  <div
                    class="image-container image-default"
                    v-if="userImage.indexOf('default.png') != -1"
                  >
                    <i class="icon-user"></i>
                  </div>
                </div>
              </template>

              <b-dropdown-item
                class="logout"
                href="http://eduaid.ir/panel/"
                target="_blank"
                >پنل کاربری</b-dropdown-item
              >
              <b-dropdown-item class="logout" @click.prevent="temam"
                >خروج</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-sm-2 logo d-flex">
        <a href="http://eduaid.ir/">
          <img src="@/assets/images/logo.png" alt />
        </a>
      </div>
      <div class="col-sm-8 d-flex navbar">
        <ul class="nav">
          <router-link tag="li" :to="'/'" class="nav-item">
            <a class="nav-link" href="#">خانه</a>
          </router-link>
          <router-link tag="li" :to="'./about-us'" class="nav-item">
            <a class="nav-link" href="#">درباره ما</a>
          </router-link>
          <router-link tag="li" :to="'./our-services'" class="nav-item">
            <a class="nav-link" href="#">خدمات ما</a>
          </router-link>
          <router-link tag="li" :to="'./contact-us'" class="nav-item">
            <a class="nav-link" href="#">تماس با ما</a>
          </router-link>
          <router-link tag="li" :to="'./faq'" class="nav-item">
            <a class="nav-link" href="#">سوالات متداول</a>
          </router-link>
        </ul>
      </div>

      <div class="col-sm-2 d-flex navbar-left nav">
        <div class="d-flex navbar-left-icon">
          <button v-b-tooltip.hover title="سبد خرید">
            <i class="icon-shopping-line"></i>
          </button>
        </div>

        <div class="left-section">
          <div
            class="d-flex align-self-center navbar-left-enter user-navigator right-section"
          >
            <b-overlay
              :show="loadingLogin"
              variant="transparent"
              blur="3px"
              rounded="sm"
              spinner-variant="warning"
              spinner-type="grow"
            >
              <b-dropdown
                v-if="['real'].indexOf(user.user_type) == -1"
                size="lg"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="icon-user user-icon"></i>
                  <i class="icon-down arrow-down"></i>
                </template>

                <b-dropdown-item class="sign-in" v-b-modal.signin-real-person
                  >ورود</b-dropdown-item
                >

                <b-dropdown-item class="sign-up" v-b-modal.signup-real-person
                  >ثبت نام</b-dropdown-item
                >
              </b-dropdown>
            </b-overlay>

            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              v-if="user.user_type == 'real'"
              no-caret
            >
              <template v-slot:button-content>
                <div class="user-logged-info">
                  <p class="name" v-text="userFullname"></p>
                  <div
                    class="image-container"
                    v-if="userImage.indexOf('default.png') == -1"
                  >
                    <img :src="userImage" :alt="userFullname" />
                  </div>
                  <div
                    class="image-container image-default"
                    v-if="userImage.indexOf('default.png') != -1"
                  >
                    <i class="icon-user"></i>
                  </div>
                </div>
              </template>

              <b-dropdown-item
                class="logout"
                href="http://eduaid.ir/panel/"
                target="_blank"
                >پنل کاربری</b-dropdown-item
              >
              <b-dropdown-item class="logout" @click.prevent="temam"
                >خروج</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </template>

    <SigninRealPerson />
    <SignupRealPerson @getPhoneNumber="codeRealPerson.phoneNumber = $event" />
    <ForgetPasswordRealPerson />
    <ActivationCodeForgetPasswordRealPerson />
    <ActivationCodeRealPerson :phone="codeRealPerson.phoneNumber" />
    <ResetPasswordRealPerson />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SigninRealPerson from "@/pages/home/modal/SigninRealPerson.vue";
import SignupRealPerson from "@/pages/home/modal/SignupRealPerson.vue";
import ForgetPasswordRealPerson from "@/pages/home/modal/ForgetPasswordRealPerson.vue";
import ActivationCodeRealPerson from "@/pages/home/modal/ActivationCodeRealPerson.vue";
import ActivationCodeForgetPasswordRealPerson from "@/pages/home/modal/ActivationCodeForgetPasswordRealPerson.vue";
import ResetPasswordRealPerson from "../home/modal/ResetPasswordRealPerson";

export default {
  name: "Header",
  data() {
    return {
      windowWidth: "",
      loadingLogin: false,
      nationalCode: "",
      codeRealPerson: {
        phoneNumber: "",
      },
      selectedSubDomain: {
        username: "",
      },
    };
  },
  components: {
    SigninRealPerson,
    SignupRealPerson,
    ForgetPasswordRealPerson,
    ActivationCodeRealPerson,
    ActivationCodeForgetPasswordRealPerson,
    ResetPasswordRealPerson,
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    userFullname() {
      return (
        (this.$store.state.user.user_fname || this.$store.state.user.fname) +
        " " +
        (this.$store.state.user.user_lname || this.$store.state.user.lname)
      );
    },
    userImage() {
      let pic;

      if (this.$store.state.user.id) {
        if (this.$store.state.user.img) {
          pic = `assets/images/user/${this.$store.state.user.img}.png`;
        } else {
          pic = "assets/images/user/default.png";
        }
      }

      return this.url + pic;
    },
  },
  created() {
    this.$store.dispatch("checkLogin");
    this.windowWidth = window.innerWidth;
  },

  methods: {
    temam() {
      this.$store.dispatch("logOutUser");
    },
  },
};
</script>
<style lang="scss">
#sidebar-right {
  //  background-color :#15B5BF !important;
  background-color: #000 !important;
  margin-top: -1rem;
  right: 0;
  width: 300px;
  position: fixed;
  .nav{
    margin-right: -1.5rem;
  }
  .logo{
    a{
      position: relative;
      top: 1.3rem;
      right: 1.3rem;
    }
  }
  svg {
    font-size: 3rem;
    color: #fff;
    top: 1.5rem;
    position: relative;
    right: 1rem;
  }
}
.b-sidebar-outer {
  z-index: 1071;
}

</style>